import { useState } from 'react';
import type { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@mui/material/styles';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import ErrorFallback from '../ErrorFallback';
import { DashboardPageInnerLayout } from './DashboardPageInnerLayout';
import * as Sentry from '@sentry/react';
import { Box } from '@mui/material';
import LoadingScreen from 'components/LoadingScreen';
import KeycloakUserService from 'utils/KeycloakUserService';
import { useAuth } from 'hooks';

interface DashboardLayoutProps {
  children?: ReactNode;
}

const DashboardLayoutRoot = experimentalStyled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
}));

const DashboardLayout: FC<DashboardLayoutProps> = () => {
  const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState<boolean>(false);
  const { user } = useAuth();

  if (!user?.role) {
    return (
      <Box sx={{ position: 'fixed', zIndex: 999, top: '0', bottom: 0, left: 0, right: 0 }}>
        <LoadingScreen />
      </Box>
    );
  }
  return (
    <DashboardLayoutRoot>
      <DashboardNavbar onSidebarMobileOpen={(): void => setIsSidebarMobileOpen(true)} />
      <DashboardSidebar
        onMobileClose={(): void => setIsSidebarMobileOpen(false)}
        openMobile={isSidebarMobileOpen}
      />
      <Sentry.ErrorBoundary fallback={ErrorFallback}>
        <DashboardPageInnerLayout>
          <Outlet />
        </DashboardPageInnerLayout>
      </Sentry.ErrorBoundary>
    </DashboardLayoutRoot>
  );
};

export default DashboardLayout;
